export default __webpack_public_path__ + "assets/b2e6a66829d8d6fb628cbfc749d2d688.svg";